import getSources from '../../api/resources/getSources';
import SelectWithFetch from './SelectWithFetch';

const SelectSources = (props) => {
  return <SelectWithFetch fetch={getSources} {...props} />;
};

export default SelectSources;
